import moment from 'moment';
import { Area } from '@antv/g2plot';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { renderTooltip } from '../../../../helpers/Tooltip';
import { getRange } from '../../../Modules/pme/screens/dashboard/widgets/mitigation-actions-trend/helper';
import { capitalizeAll } from '../../../../helpers/StringHelper';

const itemsConfig = [
  { color: '#2E90FA', key: 'own', label: 'Own Data' },
  { color: '#FAAD14', key: 'acquired', label: 'DataStore::acquired-data' },
];

const fill = itemsConfig.map((c) => c.color);

export default function useDataAccumulation({ container, data = {}, filter }) {
  const [mainGraph, setMainGraph] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const monthsArray = [];

    for (let i = 0; i < 12; i++) {
      const month = moment().add(i * -1, 'months').format('MMM YY');
      const monthNum = moment().add(i * -1, 'months').get('M');
      monthsArray.push({ label: month, key: monthNum + 1 });
    }

    monthsArray.reverse();

    let ownValue = 0;

    const own = monthsArray.map(({ label, key }, i) => {
      const { own } = data[key] || {};
      ownValue += (own || 0);

      return {
        key,
        type: 'own',
        value: ownValue,
        item: `${label.replace(' ', '\n')}`,
        label,
      }
    });

    let acquiredValue = 0;

    const acquired = monthsArray.map(({ key, label }, i) => {
      const { acquired } = data[key] || {};
      acquiredValue += (acquired || 0);

      return {
        key,
        type: 'acquired',
        value: acquiredValue,
        item: `${label.replace(' ', '\n')}`,
        label,
      }
    });

    const _data = [...own, ...acquired]

    if (container.current) {
      const customContent = (title, data) => {
        if (Array.isArray(data) && data[0]) {
          return renderTooltip({
            title: t(filter === 'datapoints' ? 'DataStore::data-points-2' : 'DataStore::data-points'),
            subTitle: data[0]?.data?.label,
            items: [
              {
                label: t('Consolidated'),
                value: Number(data[0]?.data?.value + data[1]?.data?.value).toLocaleString('en-us'),
                isTotal: true,
              },
              ...data.map((d) => {
                const itemConfig = itemsConfig.find((c) => c.key === d.name);
                return {
                  label: capitalizeAll(t(itemConfig?.label || '')),
                  color: itemConfig?.color,
                  value: Number(d.data?.value || 0).toLocaleString('en-us')
                }
              }),
            ],
          });
        }

        return '';
      };

      if (mainGraph) {
        mainGraph.update({
          data: _data,
          tooltip: { customContent },
          yAxis: {
            label: {
              style: {
                fontSize: 0
              }
            }
          },
        });
      } else {
        const area = new Area(container.current, {
          height: 250,
          data: _data,
          xField: 'item',
          localRefresh: true,
          animation: false,
          yField: 'value',
          seriesField: 'type',
          point: {
            shape: 'round',
            size: 3,
          },
          yAxis: {
            label: {
              style: {
                fontSize: 0
              }
            }
          },
          legend: false,
          color: fill,
          tooltip: {
            shared: true,
            customContent,
          },
        });
        area.render();
        setMainGraph(area);
      }
    }
  }, [container, t, data]);
}
